import React  from 'react'
import PropTypes from 'prop-types'
import { useCallback } from 'sb-hooks'
import { formatPrice } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import Button from 'components/_new/Button/Button'
import ChecklistItem from 'components/_new/ChecklistItem/ChecklistItem'

import PlanCard from 'components/upgradePlans/cards/components/PlanCard/PlanCard'
import ProductsPerMonth from 'components/upgradePlans/cards/components/ProductsPerMonth/ProductsPerMonth'
import CurrentPlanButton from 'components/upgradePlans/cards/components/CurrentPlanButton/CurrentPlanButton'

import messages from './messages'


const UpgradeMonthlyPlan = (props) => {
  const { className, data, onButtonClick } = props
  const { discount, saveValue, productPrice, productsPerPeriod, selected } = data

  const handleClick = useCallback(() => {
    if (typeof onButtonClick === 'function') {
      onButtonClick(data)
    }
  }, [ onButtonClick, data ])

  return (
    <PlanCard {...{ className, discount, saveValue }}>
      <ProductsPerMonth count={productsPerPeriod} />
      <Box mt="16">
        <Text size="18-24" semibold message={messages.plans[productsPerPeriod]} />
      </Box>
      <Box mt="4">
        <Text size="32-40" semibold tag="span" message={formatPrice(productPrice, true, true)} />
        <Text tag="span" message={messages.perProduct} />
      </Box>
      <Box mt="48" mb="60">
        <div role="list">
          <ChecklistItem iconColor="brand">
            <Text message={messages.productsAvailable} />
          </ChecklistItem>
        </div>
      </Box>
      {
        selected ? (
          <CurrentPlanButton />
        ) : (
          <Button
            title={{ ...messages.buttonTitle, values: { saveValue } }}
            size="md"
            color="brand"
            rightIcon="rightArrowSmall"
            centering
            fullWidth
            onClick={handleClick}
          />
        )
      }
    </PlanCard>
  )
}

UpgradeMonthlyPlan.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    name: PropTypes.string,
    discount: PropTypes.string,
    saveValue: PropTypes.string,
    productPrice: PropTypes.number.isRequired,
    productsPerPeriod: PropTypes.number.isRequired,
  }),
  onButtonClick: PropTypes.func.isRequired,
}


export default UpgradeMonthlyPlan
